import { FC } from 'react';
import styled from 'styled-components';

import { media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';

const TITLE_STYLE = {
  fontFamily: 'Manrope',
  fontWeight: 600,
  fontSize: 16,
  color: COLORS.colorPrimary,
};

type ModalTitle = {
  title: string;
};

export const ModalTitle: FC<ModalTitle> = ({ title }) => (
  <Container>
    <span style={TITLE_STYLE}>{title}</span>
  </Container>
);

const Container = styled.div`
  padding: 16px 24px;

  ${media.sm} {
    padding: 16px;
  }
`;
